module.exports = __webpack_public_path__ + "static/media/bg-login - Copy.40332687.png";